export type SiteLookupDataView = 'historical' | 'realtime';

export const SiteLookupDataViewValue = {
  historical: 'historical' as SiteLookupDataView,
  realtime: 'realtime' as SiteLookupDataView,
};

type GetAvailableSiteLookupDataViewsProps = {
  hasHistoricalAccess: boolean;
  hasRealTimeAccess: boolean;
};

export const getAvailableSiteLookupDataViews = ({ hasHistoricalAccess, hasRealTimeAccess }: GetAvailableSiteLookupDataViewsProps): SiteLookupDataView[] => {
  const availableDataViews: SiteLookupDataView[] = [];

  if (hasHistoricalAccess) {
    availableDataViews.push(SiteLookupDataViewValue.historical);
  }

  if (hasRealTimeAccess) {
    availableDataViews.push(SiteLookupDataViewValue.realtime);
  }

  return availableDataViews;
};
